import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69307a02"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "mb-15",
  style: {"text-align":"center"}
}, "提现支付包", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-15" }, null, -1))
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onMouseenter"]
const _hoisted_5 = { class: "d-flex justify-content--between pt-10 mb-20" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("自动匹配")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("手动匹配")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("特殊核销")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 金额浮动率 ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("： ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("±0")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("±20")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("±50")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("±100")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_16 = { class: "contatainer-main-left" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { style: {"font-weight":"normal"} }, "提现单", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-10" }, null, -1))
const _hoisted_19 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_20 = /*#__PURE__*/_createTextVNode()
const _hoisted_21 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_22 = { class: "contatainer-main-right" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { style: {"font-weight":"normal"} }, "交易流水", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-10" }, null, -1))
const _hoisted_25 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_26 = /*#__PURE__*/_createTextVNode()
const _hoisted_27 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("取消匹配")
const _hoisted_29 = /*#__PURE__*/_createTextVNode("导出已匹配数据")
const _hoisted_30 = /*#__PURE__*/_createTextVNode("同步Mars结果")
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-10" }, null, -1))
const _hoisted_32 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_33 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-10" }, null, -1))
const _hoisted_35 = /*#__PURE__*/_createTextVNode("点击查看")
const _hoisted_36 = /*#__PURE__*/_createTextVNode("取消匹配")
const _hoisted_37 = /*#__PURE__*/_createTextVNode("修改备注")
const _hoisted_38 = /*#__PURE__*/_createTextVNode("补充匹配")
const _hoisted_39 = { style: {"margin":"0 50px"} }
const _hoisted_40 = { class: "mb-15" }
const _hoisted_41 = { class: "mb-15" }
const _hoisted_42 = /*#__PURE__*/_createTextVNode("点击进行手动匹配")
const _hoisted_43 = { style: {"text-align":"right"} }
const _hoisted_44 = /*#__PURE__*/_createTextVNode("关闭")
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  style: {"color":"var(--el-color-info)"},
  class: "mb-10"
}, "如有需要，可在下方为本次匹配结果添加备注(非必填)", -1))
const _hoisted_46 = { style: {"text-align":"right"} }
const _hoisted_47 = /*#__PURE__*/_createTextVNode("关闭")
const _hoisted_48 = /*#__PURE__*/_createTextVNode("确认匹配")
const _hoisted_49 = { style: {"text-align":"right"} }
const _hoisted_50 = /*#__PURE__*/_createTextVNode("关闭")
const _hoisted_51 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_52 = { style: {"text-align":"right"} }
const _hoisted_53 = /*#__PURE__*/_createTextVNode("关闭")
const _hoisted_54 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_55 = { style: {"text-align":"left"} }
const _hoisted_56 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_57 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_58 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_59 = /*#__PURE__*/_createTextVNode()
const _hoisted_60 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_61 = {
  class: "mt-15",
  style: {"text-align":"right"}
}
const _hoisted_62 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_63 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_64 = {
  class: "mt-15",
  style: {"text-align":"right"}
}
const _hoisted_65 = /*#__PURE__*/_createTextVNode("确定")

import { ref, Ref, reactive, onBeforeMount, onActivated, onMounted, computed, watch, nextTick } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { Calendar, Search } from '@element-plus/icons-vue'
import tbMix from '@/global_mixin/tableMixin'
import { statusMap } from '@/views/typeMapping/Financial'
import dayjs from 'dayjs'
import { formatNumber, exportHandle } from '@/utils/index'
import { getDropBoxHandle } from '@/views/ViewsComponents/financial/bankDropBox'
import Api from '@/http/modules/index'
import {useRoute} from "vue-router"
import MatchTable from "@/views/ViewsComponents/CostMatchTable/matchTable.vue"

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
    // 获取国家和公司
    'GET/cost_cash_packs/detail/queryList': queryListApi,
    // 支付包列表
    'GET/cost_cash/pack':costCashPackApi,
    // 提现单列表  
    'POST/cost_cash/pack/detail':packDetailApi,
    // 交易流水列表
    'POST/cost_cash/pack/detail/cash':packDetailCashApi,
    // 自动匹配
    'POST/cost_cash/match/auto':autoMatchApi,
    // 手动匹配
    'POST/cost_cash/match/manual':handelMatchApi,
    // 已匹配列表
    'POST/cost_cash/match/page':costCashMatchApi,
    // 取消匹配
    'DELETE/cost_cash/match/cancel':cancelMatchApi,
    // 导出已匹配列表
    'POST/cost_cash/match/export':matechListsExportApi,
    // 修改备注
    'POST/cost_cash/match/update':modifyNoteApi,
    // 预匹配
    'POST/cost_cash/match/pre':preMatchApi,
    // 手动添加流水
    'POST/cost_cash/match/manual/add':cashMatchManualAddApi,
    // 同步mars结果
    'POST/cost_cash/match/sync_mars':syncMarsApi,
    // 校验金额是否一致
    'POST/cost_cash/match/checkAmount':checkAmountApi,
    // 校验金额是否一致
    'POST/cost_cash/match/special':matchSpecialApi,
    // 取消匹配校验
    'POST/cost_cash/match/cancel/validate':cancelValidateApi
} = Api




const route=useRoute()
const accountNameList=ref([])
const containerHeight=window.innerHeight-70
const tableHeight=window.innerHeight-400
const preTableHeight=window.innerHeight-200
const queryPackKey=ref("")
const filterOpt=ref("name")
const payMethodOps=[
    { label: 'PAYPAL', id: 'paypal' },
    { label: 'WISE', id: 'wise' },
    { label: 'BANKTRANSFER', id: 'banktransfer' },
    { label: 'PAYONEER', id: 'payoneer' },
    { label: 'PAYONEERBANKTRANSFER', id: 'payoneerbanktransfer' },
]
// 支付包列表
const packLists=ref([]) 
const packListsLoading=ref(false)
const getPackLists=(isFirst:boolean=false)=>{
    packListsLoading.value=true
    const params:any={
        paid:queryPackKey.value?true:false,
    }
    params[filterOpt.value]=queryPackKey.value
    costCashPackApi(params).then((res:any)=>{
        packLists.value=res
        packListsLoading.value=false
        if(isFirst){
            let packId=currentPackId.value||res[0].id
            packItemHandel(packId)
        }
    }).catch(()=>{
        packListsLoading.value=false
    })
}
// 支付包搜索功能
// const filterPackLists=computed(()=>{
//     return packLists.value.filter((el:any)=>!queryPackKey.value||el.name.search(queryPackKey.value)!=-1)
// })
// 支付包菜单功能
const currentPackId=ref<string|number>("")
const activeTab=ref('unMatched')
const packItemHandel=(id:string|number)=>{
    currentPackId.value=id
    pageInfo.page=1,
    pageInfo.size=30,
    actualPayAmoutSort.value={}
    receiptAmoutSort.value={}
    FlowsRef.value.tablCclearSort()
    cashRef.value.cashTableClearSort()
    getPackDetail()
    getCostCashMatchLists()
    getPackDetailCash()
}
const switchHandle=()=>{

}
// 未匹配菜单
const noteText='假如设置为±20%。当用户在左边勾选了一条提现记录，右边的流水就自动过滤出来这个支付金额 ±20%的流水（当浮动率为“无”时，则展示所有的流水）'
// 提现单
const pageInfo=reactive({
    page:1,
    size:30,
    total:0
})
const FlowsRef=ref()
const resourceId=ref("")
const payMethodVal=ref("")
const company=ref("")
const packDetailData=ref([])
const packdetailSelected=ref<any>([])
const packDetailDataLoading=ref(false)
const getPackDetail=(isReset:boolean=false,needClear:boolean=true)=>{
    if(isReset){
        resourceId.value=""
        payMethodVal.value=""
        company.value=""
        pageInfo.page=1
        pageInfo.size=30
    }
    let {page,size}=pageInfo
    let params={
        page,size,
        packId: currentPackId.value,
        resourceId:resourceId.value,
        payMethod:payMethodVal.value,
        company:company.value,
        sort:actualPayAmoutSort.value
    }
    packDetailDataLoading.value=true
    packDetailApi(params).then((res:any)=>{
        packDetailData.value=res.data
        pageInfo.total=res.rowCount
        packDetailDataLoading.value=false
        if(needClear){
            FlowsRef.value.tableClear()
        }
    }).catch(()=>{
        packDetailDataLoading.value=false
    })
}
const handleSelectionChange=(from:string,val:any)=>{
    switch(from){
        case 'packDetail':
            return  packdetailSelected.value=val;
        case 'costCashMatch':
            return costCashMatchSelected.value=val
        case 'flows':
            return packDetailCashSelectedData.value=val

    }
    
}
// 交易流水
let  floatAmountInfo=ref<any>({
    ratio:0,
    maxAmount:0,
    minAmount:0,
    date:"",
    accountName:"",
    remarks:"",
    costTo:"",
    costToAccount:""
})
const pageInfo2=reactive({
    page:1,
    size:30,
    total:0
})
const packDetailCashData=ref([])
const packDetailCashDataLoading=ref(false)
const packDetailCashSelectedData=ref([])
const dateChange=(date:any)=>{
    autoMatchOption.value.date=date
}
const cashRef=ref()
const getPackDetailCash=(isReset:boolean=false,needClear:boolean=true)=>{
    if(isReset){
        floatAmountInfo.value={
            ratio:0,
            maxAmount:0,
            minAmount:0,
            date:"",
            accountName:"",
            remarks:"",
            costTo:"",
            costToAccount:""
        },

        pageInfo2.page=1
        pageInfo2.size=30
    }
    let {ratio,maxAmount,minAmount,date,remarks,accountName,costTo,costToAccount}=floatAmountInfo.value
    let {page,size}=pageInfo2
    let params={
        // amounts:packdetailSelected.value.map((el:any)=>parseFloat(el.actualPaymentAmount)),
        pdIds:packdetailSelected.value.map((el:any)=>parseFloat(el.id)),
        ratio:ratio||0,maxAmount,minAmount,page,size,
        remarks,accountName,
        payMethod:payMethodVal.value,
        costTo,costToAccount,
        date:{
           from: date?dayjs(date[0]).format("YYYY-MM-DD"):'',
           to: date?dayjs(date[1]).format("YYYY-MM-DD"):""
        },
        sort:receiptAmoutSort.value
    }
    packDetailCashDataLoading.value=true
    packDetailCashApi(params).then((res:any)=>{
        packDetailCashData.value=res.data
        packDetailCashDataLoading.value=false
        pageInfo2.total=res.rowCount
        if(needClear){
            cashRef.value.cashTableClear()
        }
        
    }).catch(()=>{
        packDetailCashDataLoading.value=false
    })
}
// const selectable=(row:any)=>{
//     if(!packdetailSelected.value.length) return true
//     return packdetailSelected.value[0].resourceId==row.resourceId&&packdetailSelected.value[0].resourceCurrency==row.resourceCurrency
// }
// 自动匹配
const dialogVisible=ref(false)
const dialogVisible2=ref(false)
const textarea=ref("")
const autoLoading=ref(false)
const companyList=ref([])
const autoMatchResult=ref({})
const autoMatchDialog=ref(false)
const autoMatchOption=ref<any>({})
const preMatchData=ref([])
const preSelectedData=ref([])
const pageInfo4=reactive({
    page:1,
    size:30,
    total:0
})
// 预匹配
const preAutoMatchHandel=()=>{
    let {page,size}=pageInfo4
    let params={
        page,size,        
        packId:currentPackId.value,
        payMethod:autoMatchOption.value.payMethod||'',
        company:autoMatchOption.value.company||'',
        useCostTo:autoMatchOption.value.checked||false,
        date: {
            from:autoMatchOption.value.date&&autoMatchOption.value.date[0]?dayjs(autoMatchOption.value.date[0]).format("YYYY-MM-DD"):'',
            to:  autoMatchOption.value.date&&autoMatchOption.value.date[1]?dayjs(autoMatchOption.value.date[1]).format("YYYY-MM-DD"):''
        },
    }
    autoLoading.value=true
    preMatchApi(params).then((res:any)=>{
        autoLoading.value=false
        if(!res.data.length){
            ElMessage.warning('暂无可自动匹配的交易流水')
            return
        }
        preMatchData.value=res.data
        preMatchVisible.value=preMatchVisible.value||true
        pageInfo4.total=res.rowCount
        autoMatchDialog.value=false
    }).catch(()=>{
        autoLoading.value=false
    })
}
const closeAutoMotch=()=>{
    if(!preMatchVisible.value){
        autoMatchOption.value={checked:false}
    }
}
// 自动匹配
const matchDataLoading=ref(false)
const preAutoMatchTableRef=ref()
const autoMatchHandel=()=>{
    let params={     
        packId:currentPackId.value,
        payMethod:autoMatchOption.value.payMethod||'',
        company:autoMatchOption.value.company||'',
        useCostTo:autoMatchOption.value.checked||false,
        date: {
            from:autoMatchOption.value.date&&autoMatchOption.value.date[0]?dayjs(autoMatchOption.value.date[0]).format("YYYY-MM-DD"):'',
            to:  autoMatchOption.value.date&&autoMatchOption.value.date[1]?dayjs(autoMatchOption.value.date[1]).format("YYYY-MM-DD"):''
        },
        errorPdIds:preSelectedData.value.map((el:any)=>el.pdIds)
    }
    matchDataLoading.value=true
    autoMatchApi(params).then((res)=>{
        autoMatchResult.value=res
        dialogVisible.value=true
        preMatchVisible.value=false     
        matchDataLoading.value=false           
        getPackLists(true)
        getPackDetail()
        getCostCashMatchLists()
    })
}
const cancelPreAutoMatch=()=>{
    pageInfo4.page=1,
    pageInfo.size=30
    preAutoMatchTableRef.value!.clearSelection() //清除选中
    autoMatchOption.value={checked:false}
}
const isSpecial=ref(false)
// 手动匹配
const openHandelMatch=(type:boolean)=>{
    // 手动匹配
    if((!type&&(!packDetailCashSelectedData.value.length||!packdetailSelected.value.length))||(type&&!packdetailSelected.value.length)){
        ElMessage.warning('请勾选需要手动匹配的数据')
        return
    }
    dialogVisible2.value=true
    isSpecial.value=type
}

const handelMatchLoading=ref(false)
const handelMatch=()=>{
    if(isSpecial.value){
        handelMatchRequest()
        return
    }
    let params={
        cashIds: packdetailSelected.value.map((el:any)=>el.id),
        flowIds:packDetailCashSelectedData.value.map((el:any)=>el.id) 
    }
    checkAmountApi(params).then((res:any)=>{
        if(res.diff){
            ElMessageBox.confirm("金额不一致，是否继续核销",{confirmButtonText:'确定',cancelButtonText:'取消'}).then(()=>{
                handelMatchRequest()
            }).catch(()=>{
                dialogVisible2.value=false
            })
            return
        }
        handelMatchRequest()
    })  
}
const handelMatchRequest=()=>{
     let params={
        cashIds: packdetailSelected.value.map((el:any)=>el.id),
        flowIds:packDetailCashSelectedData.value.map((el:any)=>el.id) ,
        note: textarea.value
    }
    handelMatchLoading.value=true
    let requestFunction=isSpecial.value?matchSpecialApi:handelMatchApi
    requestFunction(params).then((res:any)=>{
        ElMessage.success("匹配成功")
        handelMatchLoading.value=false
        dialogVisible2.value=false
        getPackDetailCash()
        getPackDetail()
        getCostCashMatchLists()
    }).catch(()=>{
        handelMatchLoading.value=false
    })
}
// 已匹配列表
const costCashMatchLists=ref([])
const costCashMatchSelected=ref([])
const costCashMatchListsLoading=ref(false)
const activeNames=ref("")
const formInline=ref<any>({})
const pageInfo3=reactive({
    page:1,
    size:30,
    total:0
})
const getCostCashMatchLists=(isReset:boolean=false)=>{
    if(isReset){
        formInline.value={}
        pageInfo3.page=1
        pageInfo3.size=30
    }
    let {resourceId,type,resourceName,matchDate,payMethod,accountName}=formInline.value
    let {page,size}=pageInfo3
    let params={
        page,size,
        packId:currentPackId.value,
        resourceId:resourceId||"",
        type:type||null,
        resourceName:resourceName||"",
        payMethod:payMethod||"",
        accountName:accountName||'',
        matchDate:{
            from:matchDate&&matchDate.length?dayjs(matchDate[0]).format("YYYY-MM-DD"):"",
            to:matchDate&&matchDate.length?dayjs(matchDate[1]).format("YYYY-MM-DD"):""
        }
    }
    costCashMatchListsLoading.value=true
    costCashMatchApi(params).then((res:any)=>{
        costCashMatchLists.value=res.data
        pageInfo3.total=res.rowCount
        costCashMatchListsLoading.value=false
    }).catch(()=>{
        costCashMatchListsLoading.value=false
    })
}
// 取消匹配
const cancelLoading=ref(false)
const showCancelMatchResult=ref(false)
const cancelMatchResultList=ref<any>([])
const matchCancel=(data:Array<any>)=>{
    ElMessageBox.confirm("是否取消匹配",{confirmButtonText:"确定",cancelButtonText:'取消'}).then(()=>{
        let params={
            ids:data.map((el:any)=>el.id)
        }
        cancelValidateApi(params).then((res:any)=>{
            if(res.length){ //有值表示要去取消正常单匹配
                cancelMatchResultList.value=res
                showCancelMatchResult.value=true
                return
            }
            cancelLoading.value=true
            cancelMatchApi(params).then((res:any)=>{
                ElMessage.success("取消成功")
                cancelLoading.value=false
                // getCostCashMatchLists()
                getPackLists(true)   
            }).catch(()=>{
                cancelLoading.value=false
            })
        })
        
    })
}
const exportLoading=ref(false)
const matechListsExport= async()=>{
    let {resourceId,type,resourceName,matchDate}=formInline.value
    let {page,size}=pageInfo3
    let params={
        packId:currentPackId.value,
        resourceId:resourceId||"",
        type:type||null,
        resourceName:resourceName||"",
        matchDate:{
            from:matchDate&&matchDate.length?dayjs(matchDate[0]).format("YYYY-MM-DD"):"",
            to:matchDate&&matchDate.length?dayjs(matchDate[1]).format("YYYY-MM-DD"):""
        }
    }
    exportLoading.value=true
    await exportHandle(matechListsExportApi,params)
    exportLoading.value=false
}
// 同步Mars结果
const syncLoading=ref(false)
const syncMars=(data:Array<any>)=>{
    if(!data.length){
        ElMessage.warning('请勾选需要同步的数据')
        return
    }
    ElMessageBox.confirm("是否同步Mars结果",{confirmButtonText:"确定",cancelButtonText:'取消'}).then(()=>{
        let params={
            ids:data.map((el:any)=>el.id)
        }
        syncLoading.value=true
        syncMarsApi(params).then((res:any)=>{
            ElMessage.success("同步成功")
            syncLoading.value=false
            getCostCashMatchLists()
            // getPackLists(true)   
        }).catch(()=>{
            syncLoading.value=false
        })
    })
}
// 点击查看
const showMatchDetail=ref(false)
const recordsData=ref({})
const viewDetail=(data:any)=>{
    recordsData.value=data.records
    showMatchDetail.value=true
}
// 修改备注
const noteVisible=ref(false)
const noteTextarea=ref("")
const currentMoifyId=ref(null)
const viewNote=(data:any)=>{
    noteVisible.value=true
    noteTextarea.value=data.note
    currentMoifyId.value=data.id
}
const modifyNote=()=>{
    let params={
        id:currentMoifyId.value,
        note:noteTextarea.value
    }
    modifyNoteApi(params).then((res)=>{
        ElMessage.success("修改成功")
        noteVisible.value=false
        getCostCashMatchLists()
    })
}
const closeModifyDialog=()=>{
    noteTextarea.value=""
    currentMoifyId.value=null
}
const preMatchVisible=ref(false)
watch(()=>route.query.packId,(to)=>{
    if(to){
        packItemHandel(to)
    }
})
// 改变行颜色
const preMatchRowClass=({row}:any)=>{
    return row.preMatch?'bg-cce0ff':''
}
// 导入流水
const importCashVisiable=ref(false)
const newCashInfo=ref({
    date:"",
    accountName:"",
    remarks:"",
    costTo: "",
    costToAccount: "",
})
const cashList=ref([])
const cashListLoading=ref(false)
const importLoading=ref(false)
const pageInfo5=reactive({
    size:30,
    page:1,
    total:0
})
const cashSelectedData=ref([])
const currentHandleId=ref("")
const currentHandleData=ref<any>({})
const addMatchHandel=(data:any)=>{
    currentHandleId.value=data.id
    importCashVisiable.value=true
    currentHandleData.value=data
    getCashList(true)
}
const cashListSelect=(val:any)=>{
    cashSelectedData.value=val
}
const getCashList=(isReset:boolean=false)=>{
     if(isReset){
        newCashInfo.value={
            date:"",
            accountName:"",
            remarks:"",
            costTo: "",
            costToAccount: "",
        },

        pageInfo5.page=1
        pageInfo5.size=30
    }
    let {date,remarks,accountName,costTo,costToAccount}=newCashInfo.value
    let {page,size}=pageInfo5
    let params={
        pdIds:[],
        ratio:0,maxAmount:0,minAmount:0,page,size,
        remarks,accountName,
        payMethod:payMethodVal.value,
        costTo:costTo|| "",
        costToAccount:costToAccount|| "",
        date:{
           from: date?dayjs(date[0]).format("YYYY-MM-DD"):'',
           to: date?dayjs(date[1]).format("YYYY-MM-DD"):""
        }
    }
    cashListLoading.value=true
    packDetailCashApi(params).then((res:any)=>{
        cashList.value=res.data
        cashListLoading.value=false
        pageInfo5.total=res.rowCount
    }).catch(()=>{
        cashListLoading.value=false
    })
}
const importMatchRef=ref()
const closeImportCash=()=>{
    currentHandleId.value=''
    currentHandleData.value={}
    importMatchRef.value.cashTableClear()
    cashSelectedData.value=[]
}
const importCash= async ()=>{
    if(!cashSelectedData.value.length){
        ElMessage.warning("请选择交易流水")
        return
    }
    if(!(cashSelectedData.value.every((el:any)=>el.receiptCurrency==currentHandleData.value.receiptCurrency))){
      let res=  await  ElMessageBox.confirm("币种不一致，是否要继续补充",{confirmButtonText:'确定',cancelButtonText:"取消"})
      if(res!='confirm') return
    }
    let params={
        "id": currentHandleId.value,
        "flowIds":cashSelectedData.value.map((el:any)=>el.id)
    }
    importLoading.value=true
    cashMatchManualAddApi(params).then(()=>{
        ElMessage.success("导入成功")
        importCashVisiable.value=false
        importLoading.value=false
    }).catch(()=>{
        importLoading.value=false
    })
}

const packMouseEnter=(el:any,data:any)=>{
    data.disabled=el.target.offsetWidth>137
}
const actualPayAmoutSort=ref({})
const receiptAmoutSort=ref({})
const sortChange=({prop,order}:any)=>{
    let orderVal=order=='descending'?'DESC':'ASC'
    if(prop=='actualPaymentAmount'||prop=='resourceId'){
        if(!order){
            actualPayAmoutSort.value={}
        }else{
            actualPayAmoutSort.value=prop=='actualPaymentAmount'?{"actual_payment_amount":orderVal}:{"resource_id":orderVal}    
        }
        getPackDetail()
        return
    }     
    if(!order){
        receiptAmoutSort.value={}
    }else{
        receiptAmoutSort.value={
            "receipt_amount":orderVal
        }
    }
    getPackDetailCash()

}


onMounted(()=>{
    getPackLists(true)   
    queryListApi().then((rep: any) => {
        let { countries, companies } = rep
        companyList.value = companies
    })
    getDropBoxHandle().then((rep: any) => {
        accountNameList.value=rep.accountName
  })
})


return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_QuestionFilled = _resolveComponent("QuestionFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_container, {
      class: "cost-match-container",
      style: _normalizeStyle({height:containerHeight+'px'})
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_aside, {
          class: "contatainer-aside mr-10",
          style: {"padding":"12px"},
          width: "220px"
        }, {
          default: _withCtx(() => [
            _hoisted_1,
            _createVNode(_component_el_input, {
              modelValue: queryPackKey.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((queryPackKey).value = $event)),
              onChange: _cache[2] || (_cache[2] = ($event: any) => (getPackLists())),
              onKeydown: _cache[3] || (_cache[3] = _withKeys(($event: any) => (getPackLists()), ["enter"])),
              class: "input-with-select"
            }, {
              prepend: _withCtx(() => [
                _createVNode(_component_el_select, {
                  class: "select-text-overflow",
                  modelValue: filterOpt.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filterOpt).value = $event)),
                  placeholder: "Select",
                  style: {"width":"80px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "支付包名称",
                      value: "name"
                    }),
                    _createVNode(_component_el_option, {
                      label: "译员ID",
                      value: "resourceId"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _hoisted_2,
            _withDirectives((_openBlock(), _createElementBlock("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(packLists.value, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  onClick: ($event: any) => (packItemHandel(item.id)),
                  key: item.id,
                  class: "pack-item d-flex justify-content--between align-items-center"
                }, [
                  _createVNode(_component_el_tooltip, {
                    class: "box-item",
                    effect: "dark",
                    content: item.name,
                    placement: "top-start",
                    disabled: !item.disabled
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        onMouseenter: (val)=>packMouseEnter(val,item),
                        class: "tool-tip-text",
                        style: _normalizeStyle({color:currentPackId.value==item.id?'var(--el-color-primary)':''})
                      }, _toDisplayString(item.name), 45, _hoisted_4)
                    ]),
                    _: 2
                  }, 1032, ["content", "disabled"]),
                  _createVNode(_component_el_tooltip, {
                    effect: "light",
                    content: "未匹配数",
                    placement: "right"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_tag, {
                        type: currentPackId.value==item.id?'':'info',
                        effect: "plain",
                        round: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.matchRatio), 1)
                        ]),
                        _: 2
                      }, 1032, ["type"])
                    ]),
                    _: 2
                  }, 1024)
                ], 8, _hoisted_3))
              }), 128))
            ])), [
              [_directive_loading, packListsLoading.value]
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_main, { class: "contatainer-main" }, {
          default: _withCtx(() => [
            (currentPackId.value)
              ? (_openBlock(), _createBlock(_component_el_tabs, {
                  key: 0,
                  modelValue: activeTab.value,
                  "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((activeTab).value = $event)),
                  class: "demo-tabs",
                  onTabClick: switchHandle
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_tab_pane, {
                      label: "未匹配",
                      name: "unMatched"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          _createVNode(_component_el_space, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                size: "large",
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (autoMatchDialog.value=true)),
                                type: "primary"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_6
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_button, {
                                size: "large",
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (openHandelMatch(false)))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_7
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_button, {
                                size: "large",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (openHandelMatch(true)))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_8
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_space, null, {
                            default: _withCtx(() => [
                              _createElementVNode("span", null, [
                                _hoisted_9,
                                _createVNode(_component_el_tooltip, {
                                  effect: "light",
                                  content: noteText,
                                  placement: "top-start"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_icon, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_QuestionFilled)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _hoisted_10
                              ]),
                              _createVNode(_component_el_tag, {
                                style: {"cursor":"pointer"},
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(floatAmountInfo).ratio=0)),
                                type: _unref(floatAmountInfo).ratio==0?'':'info',
                                size: "large",
                                effect: _unref(floatAmountInfo).ratio==0?'dark':'plain'
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_11
                                ]),
                                _: 1
                              }, 8, ["type", "effect"]),
                              _createVNode(_component_el_tag, {
                                style: {"cursor":"pointer"},
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(floatAmountInfo).ratio=20)),
                                type: _unref(floatAmountInfo).ratio==20?'':'info',
                                size: "large",
                                effect: _unref(floatAmountInfo).ratio==20?'dark':'plain'
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_12
                                ]),
                                _: 1
                              }, 8, ["type", "effect"]),
                              _createVNode(_component_el_tag, {
                                style: {"cursor":"pointer"},
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (_unref(floatAmountInfo).ratio=50)),
                                type: _unref(floatAmountInfo).ratio==50?'':'info',
                                size: "large",
                                effect: _unref(floatAmountInfo).ratio==50?'dark':'plain'
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_13
                                ]),
                                _: 1
                              }, 8, ["type", "effect"]),
                              _createVNode(_component_el_tag, {
                                style: {"cursor":"pointer"},
                                onClick: _cache[10] || (_cache[10] = ($event: any) => (_unref(floatAmountInfo).ratio=100)),
                                type: _unref(floatAmountInfo).ratio==100?'':'info',
                                size: "large",
                                effect: _unref(floatAmountInfo).ratio==100?'dark':'plain'
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_14
                                ]),
                                _: 1
                              }, 8, ["type", "effect"]),
                              _createVNode(_component_el_input, {
                                placeholder: "自定义浮动率",
                                modelValue: _unref(floatAmountInfo).ratio,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(floatAmountInfo).ratio) = $event)),
                                style: {"width":"100px"}
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_el_space, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    placeholder: "自定义最小金额",
                                    modelValue: _unref(floatAmountInfo).minAmount,
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(floatAmountInfo).minAmount) = $event)),
                                    style: {"width":"100px"}
                                  }, null, 8, ["modelValue"]),
                                  _hoisted_15,
                                  _createVNode(_component_el_input, {
                                    placeholder: "自定义最大金额",
                                    modelValue: _unref(floatAmountInfo).maxAmount,
                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(floatAmountInfo).maxAmount) = $event)),
                                    style: {"width":"100px"}
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _createVNode(_component_el_row, { gutter: 10 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_16, [
                                  _hoisted_17,
                                  _hoisted_18,
                                  _createVNode(_component_el_form, { inline: "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_col, { span: 12 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_form_item, { label: "译员ID：" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_el_input, {
                                                    modelValue: resourceId.value,
                                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((resourceId).value = $event))
                                                  }, null, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_el_col, { span: 12 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_form_item, { label: "支付方式" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_el_select, {
                                                    modelValue: payMethodVal.value,
                                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((payMethodVal).value = $event)),
                                                    placeholder: "请选择支付方式"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(payMethodOps, (item) => {
                                                        return _createVNode(_component_el_option, {
                                                          key: item.id,
                                                          label: item.label,
                                                          value: item.id
                                                        }, null, 8, ["label", "value"])
                                                      }), 64))
                                                    ]),
                                                    _: 1
                                                  }, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_el_col, { span: 12 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_form_item, { label: "付款公司" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_el_select, {
                                                    modelValue: company.value,
                                                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((company).value = $event)),
                                                    placeholder: "请选择付款公司"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(companyList.value, (item) => {
                                                        return (_openBlock(), _createBlock(_component_el_option, {
                                                          key: item,
                                                          label: item,
                                                          value: item
                                                        }, null, 8, ["label", "value"]))
                                                      }), 128))
                                                    ]),
                                                    _: 1
                                                  }, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_el_col, { span: 12 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_form_item, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_el_button, {
                                                    type: "primary",
                                                    onClick: _cache[17] || (_cache[17] = ($event: any) => (getPackDetail()))
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _hoisted_19
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _hoisted_20,
                                                  _createVNode(_component_el_button, {
                                                    onClick: _cache[18] || (_cache[18] = ($event: any) => (getPackDetail(true)))
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _hoisted_21
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(MatchTable, {
                                    showTotal: true,
                                    ref_key: "FlowsRef",
                                    ref: FlowsRef,
                                    onSort_change: sortChange,
                                    sortAble: 'custom',
                                    tableLoading: packDetailDataLoading.value,
                                    tableData: packDetailData.value,
                                    onSelectionChange: _cache[19] || (_cache[19] = (val)=>handleSelectionChange('packDetail',val))
                                  }, null, 8, ["tableLoading", "tableData"]),
                                  _createElementVNode("span", null, "当前选中 " + _toDisplayString(packdetailSelected.value.length) + " 条", 1),
                                  _createVNode(_component_el_pagination, {
                                    "current-page": _unref(pageInfo).page,
                                    "onUpdate:current-page": _cache[20] || (_cache[20] = ($event: any) => ((_unref(pageInfo).page) = $event)),
                                    "page-size": _unref(pageInfo).size,
                                    "onUpdate:page-size": _cache[21] || (_cache[21] = ($event: any) => ((_unref(pageInfo).size) = $event)),
                                    "page-sizes": [10, 30, 60, 100],
                                    layout: " prev, pager, next,sizes,total",
                                    total: _unref(pageInfo).total,
                                    onSizeChange: _cache[22] || (_cache[22] = ()=>getPackDetail(false,false)),
                                    onCurrentChange: _cache[23] || (_cache[23] = ()=>getPackDetail(false,false))
                                  }, null, 8, ["current-page", "page-size", "total"])
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_22, [
                                  _hoisted_23,
                                  _hoisted_24,
                                  _createVNode(_component_el_form, {
                                    inline: "",
                                    "label-position": "right"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_col, { span: 12 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_form_item, { label: "账户简称：" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_el_input, {
                                                    modelValue: _unref(floatAmountInfo).accountName,
                                                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_unref(floatAmountInfo).accountName) = $event))
                                                  }, null, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_el_col, { span: 12 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_form_item, { label: "收付方名称：" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_el_input, {
                                                    modelValue: _unref(floatAmountInfo).costTo,
                                                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_unref(floatAmountInfo).costTo) = $event))
                                                  }, null, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_el_col, { span: 12 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_form_item, { label: "收付方账号：" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_el_input, {
                                                    modelValue: _unref(floatAmountInfo).costToAccount,
                                                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_unref(floatAmountInfo).costToAccount) = $event))
                                                  }, null, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_el_col, { span: 12 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_form_item, { label: "备注：" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_el_input, {
                                                    modelValue: _unref(floatAmountInfo).remarks,
                                                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_unref(floatAmountInfo).remarks) = $event))
                                                  }, null, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_el_col, { span: 14 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_form_item, { label: "日期：" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_el_date_picker, {
                                                    type: "daterange",
                                                    "range-separator": "至",
                                                    "start-placeholder": "开始日期",
                                                    "end-placeholder": "结束日期",
                                                    modelValue: _unref(floatAmountInfo).date,
                                                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_unref(floatAmountInfo).date) = $event)),
                                                    onChange: dateChange,
                                                    style: {"width":"100%"}
                                                  }, null, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_el_col, { span: 10 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_form_item, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_el_button, {
                                                    type: "primary",
                                                    onClick: _cache[29] || (_cache[29] = ($event: any) => (getPackDetailCash()))
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _hoisted_25
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _hoisted_26,
                                                  _createVNode(_component_el_button, {
                                                    onClick: _cache[30] || (_cache[30] = ($event: any) => (getPackDetailCash(true)))
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _hoisted_27
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(MatchTable, {
                                    ref_key: "cashRef",
                                    ref: cashRef,
                                    sortAble: 'custom',
                                    onSort_change: sortChange,
                                    isFlows: true,
                                    tableLoading: packDetailCashDataLoading.value,
                                    tableData: packDetailCashData.value,
                                    onSelectionChange: _cache[31] || (_cache[31] = (val)=>handleSelectionChange('flows',val))
                                  }, null, 8, ["tableLoading", "tableData"]),
                                  _createVNode(_component_el_pagination, {
                                    "current-page": _unref(pageInfo2).page,
                                    "onUpdate:current-page": _cache[32] || (_cache[32] = ($event: any) => ((_unref(pageInfo2).page) = $event)),
                                    "page-size": _unref(pageInfo2).size,
                                    "onUpdate:page-size": _cache[33] || (_cache[33] = ($event: any) => ((_unref(pageInfo2).size) = $event)),
                                    "page-sizes": [10, 30, 60, 100],
                                    layout: " prev, pager, next,sizes,jumper,total",
                                    total: _unref(pageInfo2).total,
                                    onSizeChange: _cache[34] || (_cache[34] = ()=>getPackDetailCash(false,false)),
                                    onCurrentChange: _cache[35] || (_cache[35] = ()=>getPackDetailCash(false,false))
                                  }, null, 8, ["current-page", "page-size", "total"])
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_tab_pane, {
                      label: "已匹配",
                      name: "matched"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_space, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              loading: cancelLoading.value,
                              onClick: _cache[36] || (_cache[36] = ($event: any) => (matchCancel(costCashMatchSelected.value)))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_28
                              ]),
                              _: 1
                            }, 8, ["loading"]),
                            _createVNode(_component_el_button, {
                              onClick: matechListsExport,
                              loading: exportLoading.value
                            }, {
                              default: _withCtx(() => [
                                _hoisted_29
                              ]),
                              _: 1
                            }, 8, ["loading"]),
                            _createVNode(_component_el_button, {
                              onClick: _cache[37] || (_cache[37] = ($event: any) => (syncMars(costCashMatchSelected.value))),
                              loading: syncLoading.value,
                              disabled: ""
                            }, {
                              default: _withCtx(() => [
                                _hoisted_30
                              ]),
                              _: 1
                            }, 8, ["loading"])
                          ]),
                          _: 1
                        }),
                        _hoisted_31,
                        _createVNode(_component_el_collapse, {
                          style: {"background":"var(--el-collapse-content-bg-color)"},
                          modelValue: activeNames.value,
                          "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((activeNames).value = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_collapse_item, {
                              style: {"background":"var(--el-collapse-content-bg-color)"},
                              title: "已匹配数据-搜索",
                              name: "1"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form, {
                                  inline: true,
                                  model: formInline.value,
                                  class: "demo-form-inline"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_form_item, { label: "译员ID" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: formInline.value.resourceId,
                                          "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((formInline.value.resourceId) = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, { label: "译员名称" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: formInline.value.resourceName,
                                          "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((formInline.value.resourceName) = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, { label: "匹配方式" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_select, {
                                          modelValue: formInline.value.type,
                                          "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((formInline.value.type) = $event)),
                                          placeholder: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_option, {
                                              label: "手动匹配",
                                              value: "manual"
                                            }),
                                            _createVNode(_component_el_option, {
                                              label: "自动匹配",
                                              value: "system"
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, { label: "支付方式" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_select, {
                                          modelValue: formInline.value.payMethod,
                                          "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((formInline.value.payMethod) = $event)),
                                          placeholder: "请选择支付方式"
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(payMethodOps, (item) => {
                                              return _createVNode(_component_el_option, {
                                                key: item.id,
                                                label: item.label,
                                                value: item.id
                                              }, null, 8, ["label", "value"])
                                            }), 64))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, { label: "账户简称" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_select, {
                                          filterable: "",
                                          modelValue: formInline.value.accountName,
                                          "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((formInline.value.accountName) = $event)),
                                          placeholder: "请选择账户简称"
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accountNameList.value, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item.id,
                                                label: item.label,
                                                value: item.id
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, { label: "日期" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_date_picker, {
                                          modelValue: formInline.value.matchDate,
                                          "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((formInline.value.matchDate) = $event)),
                                          type: "daterange",
                                          "range-separator": "至",
                                          "start-placeholder": "开始日期",
                                          "end-placeholder": "结束日期"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_button, {
                                          type: "primary",
                                          onClick: _cache[44] || (_cache[44] = ($event: any) => (getCostCashMatchLists()))
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_32
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_button, {
                                          onClick: _cache[45] || (_cache[45] = ($event: any) => (getCostCashMatchLists(true)))
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_33
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["model"]),
                                _hoisted_34
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                          "row-class-name": preMatchRowClass,
                          onSelectionChange: _cache[47] || (_cache[47] = (val)=>handleSelectionChange('costCashMatch',val)),
                          height: tableHeight,
                          class: "mt-20 mb-20",
                          data: costCashMatchLists.value,
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_table_column, {
                              type: "selection",
                              width: "55"
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "resourceId",
                              label: "译员ID",
                              width: "100"
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "resourceName",
                              label: "译员名称",
                              width: "140",
                              "show-overflow-tooltip": ""
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "payMethod",
                              label: "支付方式",
                              formatter: (row)=>payMethodOps.find((el)=>el.id==row.payMethod).label,
                              width: "140"
                            }, null, 8, ["formatter"]),
                            _createVNode(_component_el_table_column, {
                              prop: "address",
                              label: "匹配结果"
                            }, {
                              default: _withCtx(({row}) => [
                                _createVNode(_component_el_link, {
                                  underline: false,
                                  onClick: ($event: any) => (viewDetail(row)),
                                  type: "primary"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_35
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "operator",
                              label: "匹配人",
                              width: "120"
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "createTime",
                              label: "匹配日期",
                              width: "120",
                              formatter: (row)=>_unref(dayjs)(row.createTime).format('YYYY-MM-DD')
                            }, null, 8, ["formatter"]),
                            _createVNode(_component_el_table_column, {
                              prop: "updateTime",
                              label: "修改日期",
                              width: "120",
                              formatter: (row)=>_unref(dayjs)(row.createTime).format('YYYY-MM-DD')
                            }, null, 8, ["formatter"]),
                            _createVNode(_component_el_table_column, {
                              prop: "type",
                              label: "匹配方式",
                              formatter: (row)=>row.type=='system'?'自动匹配':'手动匹配'
                            }, null, 8, ["formatter"]),
                            _createVNode(_component_el_table_column, {
                              prop: "paymentCurrency",
                              label: "支付币别"
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "afterDeductAmount",
                              label: "扣除手续费/税后金额",
                              width: "160"
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "actualPaymentAmount",
                              label: "支付金额"
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "paypalPaymentAmount",
                              label: "paypal支付译员金额"
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "cloudPaymentAmount",
                              label: "云账户支付译员金额"
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "receiptCurrency",
                              label: "收款币别"
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "receiptAmount",
                              label: "收款金额"
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "note",
                              label: "备注",
                              width: "100",
                              "show-overflow-tooltip": ""
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "address",
                              label: "操作",
                              width: "220",
                              fixed: "right"
                            }, {
                              default: _withCtx(({row}) => [
                                _createVNode(_component_el_space, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_link, {
                                      underline: false,
                                      type: "primary",
                                      onClick: ($event: any) => (matchCancel([row]))
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_36
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]),
                                    _createVNode(_component_el_link, {
                                      underline: false,
                                      type: "primary",
                                      onClick: ($event: any) => (viewNote(row))
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_37
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]),
                                    _createVNode(_component_el_link, {
                                      underline: false,
                                      type: "primary",
                                      onClick: ($event: any) => (addMatchHandel(row))
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_38
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["data"])), [
                          [_directive_loading, costCashMatchListsLoading.value]
                        ]),
                        _createVNode(_component_el_pagination, {
                          "current-page": _unref(pageInfo3).page,
                          "onUpdate:current-page": _cache[48] || (_cache[48] = ($event: any) => ((_unref(pageInfo3).page) = $event)),
                          "page-size": _unref(pageInfo3).size,
                          "onUpdate:page-size": _cache[49] || (_cache[49] = ($event: any) => ((_unref(pageInfo3).size) = $event)),
                          "page-sizes": [10, 30, 60, 100],
                          layout: " prev, pager, next",
                          total: _unref(pageInfo3).total,
                          onSizeChange: _cache[50] || (_cache[50] = ()=>getCostCashMatchLists()),
                          onCurrentChange: _cache[51] || (_cache[51] = ()=>getCostCashMatchLists())
                        }, null, 8, ["current-page", "page-size", "total"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["style"]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((dialogVisible).value = $event)),
      title: "自动匹配结果",
      width: "400px",
      center: "",
      "show-close": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_43, [
          _createVNode(_component_el_button, {
            onClick: _cache[54] || (_cache[54] = ($event: any) => (dialogVisible.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_44
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("p", _hoisted_40, "总共：" + _toDisplayString(autoMatchResult.value.total) + "条，匹配成功：" + _toDisplayString(autoMatchResult.value.success) + "条", 1),
          _createElementVNode("p", _hoisted_41, [
            _createTextVNode("匹配失败：" + _toDisplayString(autoMatchResult.value.fail) + "条，", 1),
            _createVNode(_component_el_link, {
              onClick: _cache[53] || (_cache[53] = ($event: any) => (dialogVisible.value = false)),
              underline: false,
              type: "primary"
            }, {
              default: _withCtx(() => [
                _hoisted_42
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      onClose: _cache[58] || (_cache[58] = ($event: any) => (textarea.value='')),
      modelValue: dialogVisible2.value,
      "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((dialogVisible2).value = $event)),
      title: "提示",
      width: "400px",
      center: ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_46, [
          _createVNode(_component_el_space, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                onClick: _cache[57] || (_cache[57] = ($event: any) => (dialogVisible2.value = false))
              }, {
                default: _withCtx(() => [
                  _hoisted_47
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                loading: handelMatchLoading.value,
                type: "primary",
                onClick: handelMatch
              }, {
                default: _withCtx(() => [
                  _hoisted_48
                ]),
                _: 1
              }, 8, ["loading"])
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_45,
        _createVNode(_component_el_input, {
          modelValue: textarea.value,
          "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((textarea).value = $event)),
          rows: 5,
          type: "textarea"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: showMatchDetail.value,
      "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((showMatchDetail).value = $event)),
      title: "",
      width: "80%"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tabs, { type: "border-card" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tab_pane, { label: "提现单" }, {
              default: _withCtx(() => [
                _createVNode(MatchTable, {
                  showSelection: false,
                  tableData: recordsData.value.packDetails
                }, null, 8, ["tableData"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_tab_pane, { label: "交易流水" }, {
              default: _withCtx(() => [
                _createVNode(MatchTable, {
                  showSelection: false,
                  isFlows: true,
                  tableData: recordsData.value.flows
                }, null, 8, ["tableData"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      onClose: closeModifyDialog,
      modelValue: noteVisible.value,
      "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((noteVisible).value = $event)),
      title: "修改备注",
      width: "400px"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_49, [
          _createVNode(_component_el_space, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                onClick: _cache[62] || (_cache[62] = ($event: any) => (noteVisible.value = false))
              }, {
                default: _withCtx(() => [
                  _hoisted_50
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: modifyNote
              }, {
                default: _withCtx(() => [
                  _hoisted_51
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          modelValue: noteTextarea.value,
          "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((noteTextarea).value = $event)),
          rows: 6,
          placeholder: "请输入备注",
          type: "textarea"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      onClose: closeAutoMotch,
      modelValue: autoMatchDialog.value,
      "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((autoMatchDialog).value = $event)),
      title: "自动匹配",
      width: "480px"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_52, [
          _createVNode(_component_el_space, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                onClick: _cache[68] || (_cache[68] = ($event: any) => (autoMatchDialog.value = false))
              }, {
                default: _withCtx(() => [
                  _hoisted_53
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                loading: autoLoading.value,
                onClick: preAutoMatchHandel
              }, {
                default: _withCtx(() => [
                  _hoisted_54
                ]),
                _: 1
              }, 8, ["loading"])
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          inline: true,
          "label-width": "90",
          model: autoMatchOption.value
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "支付方式" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: autoMatchOption.value.payMethod,
                  "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((autoMatchOption.value.payMethod) = $event)),
                  placeholder: "请选择支付方式"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(payMethodOps, (item) => {
                      return _createVNode(_component_el_option, {
                        key: item.id,
                        label: item.label,
                        value: item.id
                      }, null, 8, ["label", "value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "付款公司" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: autoMatchOption.value.company,
                  "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((autoMatchOption.value.company) = $event)),
                  placeholder: "请选择付款公司"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(companyList.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item,
                        label: item,
                        value: item
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "日期" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  type: "daterange",
                  "range-separator": "至",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期",
                  modelValue: autoMatchOption.value.date,
                  "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((autoMatchOption.value.date) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: " " }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox, {
                  modelValue: autoMatchOption.value.checked,
                  "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => ((autoMatchOption.value.checked) = $event)),
                  label: "收付方名称"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "自动匹配详情",
      onClose: cancelPreAutoMatch,
      modelValue: preMatchVisible.value,
      "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => ((preMatchVisible).value = $event)),
      fullscreen: ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_55, [
          _createVNode(_component_el_button, {
            onClick: _cache[73] || (_cache[73] = ($event: any) => (preMatchVisible.value=false))
          }, {
            default: _withCtx(() => [
              _hoisted_56
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: autoMatchHandel,
            loading: matchDataLoading.value
          }, {
            default: _withCtx(() => [
              _hoisted_57
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          ref_key: "preAutoMatchTableRef",
          ref: preAutoMatchTableRef,
          height: preTableHeight,
          "row-key": "pdIds",
          onSelectionChange: _cache[70] || (_cache[70] = (val)=>{preSelectedData.value=val}),
          data: preMatchData.value,
          border: "",
          style: {"width":"100%"},
          "default-expand-all": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              type: "selection",
              "reserve-selection": true
            }),
            _createVNode(_component_el_table_column, {
              prop: "packDetail[resourceId]",
              label: "译员ID"
            }),
            _createVNode(_component_el_table_column, {
              prop: "packDetail[resourceName]",
              label: "译员名字",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "packDetail[payMethod]",
              label: "支付方式"
            }),
            _createVNode(_component_el_table_column, {
              prop: "packDetail[accountNumber]",
              label: "账号",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "packDetail[payCurrency]",
              label: "支付币种"
            }),
            _createVNode(_component_el_table_column, {
              prop: "packDetail[actualPaymentAmount]",
              label: "支付金额"
            }),
            _createVNode(_component_el_table_column, {
              prop: "packDetail[paypalPaymentAmount]",
              label: "paypal支付译员金额"
            }),
            _createVNode(_component_el_table_column, {
              prop: "packDetail[cloudPaymentAmount]",
              label: "云账户支付译员金额"
            }),
            _createVNode(_component_el_table_column, {
              prop: "empty",
              label: "",
              "class-name": "empty-column",
              width: "20"
            }),
            _createVNode(_component_el_table_column, {
              prop: "flow[accountName]",
              label: "账户简称",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "flow[collectionAt]",
              label: "日期",
              width: "200",
              formatter: (row)=>_unref(dayjs)(row.flow.collectionAt).format('YYYY-MM-DD HH:mm:ss')
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              prop: "flow[receiptAmount]",
              label: "收款金额"
            }),
            _createVNode(_component_el_table_column, {
              prop: "flow[costToAccount]",
              label: "收付方账号",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "flow[receiptCurrency]",
              label: "收款币别"
            }),
            _createVNode(_component_el_table_column, {
              prop: "flow[remarks]",
              label: "备注"
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, autoLoading.value]
        ]),
        _createVNode(_component_el_pagination, {
          "current-page": _unref(pageInfo4).page,
          "onUpdate:current-page": _cache[71] || (_cache[71] = ($event: any) => ((_unref(pageInfo4).page) = $event)),
          "page-size": _unref(pageInfo4).size,
          "onUpdate:page-size": _cache[72] || (_cache[72] = ($event: any) => ((_unref(pageInfo4).size) = $event)),
          "page-sizes": [10, 30, 60, 100],
          layout: " prev, pager, next,sizes",
          total: _unref(pageInfo4).total,
          onSizeChange: preAutoMatchHandel,
          onCurrentChange: preAutoMatchHandel
        }, null, 8, ["current-page", "page-size", "total"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      onClose: closeImportCash,
      modelValue: importCashVisiable.value,
      "onUpdate:modelValue": _cache[88] || (_cache[88] = ($event: any) => ((importCashVisiable).value = $event)),
      title: "",
      width: "80%"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_61, [
          _createVNode(_component_el_button, {
            onClick: _cache[87] || (_cache[87] = ($event: any) => (importCashVisiable.value=false))
          }, {
            default: _withCtx(() => [
              _hoisted_62
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            loading: importLoading.value,
            onClick: importCash
          }, {
            default: _withCtx(() => [
              _hoisted_63
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          inline: "",
          "label-position": "right"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "账户简称：" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: newCashInfo.value.accountName,
                  "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => ((newCashInfo.value.accountName) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "备注：" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: newCashInfo.value.remarks,
                  "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event: any) => ((newCashInfo.value.remarks) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "收付方名称：" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: newCashInfo.value.costTo,
                  "onUpdate:modelValue": _cache[77] || (_cache[77] = ($event: any) => ((newCashInfo.value.costTo) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "收付方账号" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: newCashInfo.value.costToAccount,
                  "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event: any) => ((newCashInfo.value.costToAccount) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "日期：" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  type: "daterange",
                  "range-separator": "至",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期",
                  modelValue: newCashInfo.value.date,
                  "onUpdate:modelValue": _cache[79] || (_cache[79] = ($event: any) => ((newCashInfo.value.date) = $event)),
                  onChange: dateChange
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[80] || (_cache[80] = ($event: any) => (getCashList()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_58
                  ]),
                  _: 1
                }),
                _hoisted_59,
                _createVNode(_component_el_button, {
                  onClick: _cache[81] || (_cache[81] = ($event: any) => (getCashList(true)))
                }, {
                  default: _withCtx(() => [
                    _hoisted_60
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(MatchTable, {
          ref_key: "importMatchRef",
          ref: importMatchRef,
          isFlows: true,
          tableLoading: cashListLoading.value,
          tableData: cashList.value,
          onSelectionChange: _cache[82] || (_cache[82] = (val)=>cashListSelect(val))
        }, null, 8, ["tableLoading", "tableData"]),
        _createVNode(_component_el_pagination, {
          "current-page": _unref(pageInfo5).page,
          "onUpdate:current-page": _cache[83] || (_cache[83] = ($event: any) => ((_unref(pageInfo5).page) = $event)),
          "page-size": _unref(pageInfo5).size,
          "onUpdate:page-size": _cache[84] || (_cache[84] = ($event: any) => ((_unref(pageInfo5).size) = $event)),
          "page-sizes": [10, 30, 60, 100],
          layout: " prev, pager, next, sizes",
          total: _unref(pageInfo5).total,
          onSizeChange: _cache[85] || (_cache[85] = ()=>getCashList()),
          onCurrentChange: _cache[86] || (_cache[86] = ()=>getCashList())
        }, null, 8, ["current-page", "page-size", "total"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      onClose: _cache[90] || (_cache[90] = ($event: any) => (cancelMatchResultList.value=[])),
      modelValue: showCancelMatchResult.value,
      "onUpdate:modelValue": _cache[91] || (_cache[91] = ($event: any) => ((showCancelMatchResult).value = $event)),
      title: "",
      width: "40%"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_64, [
          _createVNode(_component_el_button, {
            onClick: _cache[89] || (_cache[89] = ($event: any) => (showCancelMatchResult.value=false)),
            type: "primary"
          }, {
            default: _withCtx(() => [
              _hoisted_65
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cancelMatchResultList.value, (item, index) => {
          return (_openBlock(), _createElementBlock("p", { key: index }, _toDisplayString(item), 1))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})